import PropTypes from "prop-types";
import React, { useEffect, useCallback, useState } from "react";

import withRouter from "../Common/withRouter";
import avatar from "../../../src/assets/images/nav4.svg";
import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeTopbarTheme,
  changeSidebarSize,
  changeLayoutWidth,
  showRightSidebarAction,
} from "../../store/actions";

import Header from "./Header";
import Sidebar from "./Sidebar";

import Rightbar from "../CommonForBoth/Rightbar";

import Footer from "./Footer";

import { Navbar, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  FormGroup,
  Nav,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import SettingOffcanvas from "../CommonForBoth/SettingOffcanvas";
import { useLocation } from "react-router-dom";
import mail from "../../assets/images/mail.svg";
import bell from "../../assets/images/noti-bell.svg";
import nav1 from "../../assets/images/nav1.png";
import nav2 from "../../assets/images/nav2.png";
import nav3 from "../../assets/images/nav3.png";
import nav4 from "../../assets/images/nav4.svg";
import plus from "../../../src/assets/Plus.svg";
import logoH from "../../../src/assets/logoH.svg";
import { useNavigate } from "react-router-dom";
import { get } from "../../api/axios";
import endpoints from "../../api/endpoints";
import { toast } from "react-toastify";
import { setNotificaiton } from "../../store/slices/authSlice";
import { toggle } from "../../store/slices/authSlice";
const Layout = (props) => {
  const { appRole, userPermissions } = useSelector((state) => {
    return state.auth.currentUser;
  });
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [staffImage, setStaffImage] = useState(null);
  const [staffCount, setStaffCount] = useState(null);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [modalOpen, setModalOpen] = useState(false);

  const isToggled = useSelector((state) => state.auth.isToggled);
  const toggleSidebar = () => {
    setIsSidebarVisible((prevState) => !prevState);
  };

  const fetchStaffImage = async () => {
    try {
      const response = await get(`${endpoints.staffImage}`);
      setStaffImage(response?.data?.data);
      setStaffCount(response?.data);
    } catch (error) {
      console.error("Error fetching staff image:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchStaffImage();
  }, []);
  const navigate = useNavigate();

  const handleAddStaff = () => {
    navigate("/add-staff");
  };
  const handleSettingStaff = () => {
    navigate("/profile-setting");
  };
  const handlelogout = () => {
    navigate("/logout");
  };

  const location = useLocation();
  const pathName = location.pathname;
  const [show, setShow] = useState(false);
  const [icon, setIcon] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const isPreloader = useSelector((state) => state.settings.isPreloader);
  const layoutType = useSelector((state) => state.settings.layoutType);
  const leftSideBarTheme = useSelector(
    (state) => state.settings.leftSideBarTheme
  );
  const leftSideBarType = useSelector(
    (state) => state.settings.leftSideBarType
  );
  const isMobile = useSelector((state) => state.settings.isMobile);

  useEffect(() => {
    if (isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  }, [isPreloader, pathName]);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const userId = localStorage.getItem("userId");

  const [profileData, setProfileData] = useState({
    profileImage: "",
  });

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        if (userId) {
          const response = await get(`${endpoints.user}/${userId}`);
          if (response?.status === 200 && response?.data?.data) {
            setProfileData(response?.data?.data);
          } else {
          }
        }
      } catch (error) {
        toast.error("Error fetching profile data");
      }
    };

    fetchProfileData();
  }, [userId]);
  const toggleDropdown = (userId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [userId]: !prevState[userId],
    }));
  };
  function tToggle() {
    setIcon((prevState) => !prevState);
    var body = document.body;
    var windowSize = document.documentElement.clientWidth;

    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");
    if (windowSize > 991) {
      body.getAttribute("data-sidebar-size") === "sm" && windowSize > 991
        ? body.setAttribute("data-sidebar-size", "lg")
        : body.setAttribute("data-sidebar-size", "sm");
    }
  }
  const { currentUser, notificationFlag } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  return (
    <React.Fragment className="hide-scrollbar">
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="uil-shutter-alt spin-icon"></i>
          </div>
        </div>
      </div>

      <div id="layout-wrapper" className="hide-scrollbar">
        <div
          className={` py-1 position-sticky ${
            isScrolled ? "bg-white shadow" : ""
          }`}
          style={{ top: 0, zIndex: 1000 }}
        >
          <Navbar
            light
            expand="md"
            className={`d-flex flex-nowrap justify-content-between align-items-center position-sticky`}
          >
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                <button
                  className="rounded-circle bg-brand-orange d-flex justify-content-center align-items-center border-0"
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "56px",
                    boxShadow: "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
                  }}
                  onClick={() =>
                    appRole == "admin" || appRole == "staff"
                      ? navigate("/dashboard")
                      : navigate("/gymDashboard")
                  }
                >
                  <img
                    src={logoH}
                    alt="logo"
                    style={{
                      objectFit: "cover",

                      height: "32px",
                      width: "32px",
                    }}
                  />
                </button>
              </div>
              <div className="ms-2">
                <h4 className="mb-0 ff-sora fw-bold primary-black font-size-18  text-capitalize">
                  Welcome, {currentUser?.firstName} {currentUser?.lastName}
                </h4>

                <p className="fw-normal ff-sora secondary-black mb-0 font-size-12">
                  Live your life perfectly.
                </p>
              </div>
            </div>
            <div className=" d-flex align-items-center ">
              <div className="d-flex align-items-center px-5 mx-5 d-none d-lg-flex">
                {currentUser.userPermissions?.staff?.["Create Staff"] && (
                  <>
                    {staffImage?.length > 0 ? (
                      staffImage.slice(0, 4).map((image, index) => (
                        <div key={index}>
                          <img
                            src={
                              image?.additionalInfo?.profileImage == null
                                ? avatar
                                : `${process.env.REACT_APP_IMG_URL}${image?.additionalInfo?.profileImage}`
                            }
                            alt={`Profile`}
                            style={{
                              marginLeft: "-10px",
                              width: "50px",
                              height: "50px",
                              boxShadow:
                                "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
                              borderRadius: "80px",
                              objectFit: "cover",
                              borderWidth: "2px",
                              borderStyle: "solid",
                              borderColor: "white",
                            }}
                          />
                        </div>
                      ))
                    ) : (
                      <p className="ff-sora font-size-14 fw-normal d-flex align-item-center me-lg-3 pt-3">
                        No staff images available.
                      </p>
                    )}
                    <div
                      className="rounded-circle button-black d-flex justify-content-center align-items-center text-white font-size-16 fw-normal ff-sora"
                      style={{
                        marginLeft: "-10px",
                        width: "50px",
                        height: "50px",
                        boxShadow: "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
                        borderRadius: "80px",
                        borderWidth: "2px",
                        borderStyle: "solid",
                        borderColor: "white",
                      }}
                    >
                      {staffCount?.count > 4
                        ? `${staffCount?.count - 4}+`
                        : staffCount?.count}
                    </div>
                  </>
                )}
                {currentUser.userPermissions?.staff?.["Create Staff"] && (
                  <Button
                    className="ms-2 rounded-pill d-flex justify-content-center align-items-center font-size-16
                "
                    style={{
                      boxShadow: "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
                    }}
                    onClick={handleAddStaff}
                  >
                    <img
                      className="me-2"
                      src={plus}
                      alt={"plus"}
                      style={{
                        width: "16px",
                        height: "16px",
                        objectFit: "cover",
                      }}
                    />
                    Add Staff
                  </Button>
                )}
              </div>
              <button
                type="button"
                onClick={() => {
                  tToggle();
                  dispatch(toggle());
                }}
                className="btn btn-sm px-3 btn-none d-block d-lg-none font-size-16 header-item waves-effect vertical-menu-btn d-flex justify-content-center align-items-center bg-circle rounded-circle me-2"
                id="vertical-menu-btn"
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50px",
                  boxShadow: "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
                }}
              >
                <i
                  className={`fa ${
                    isToggled == true ? "fa-bars" : "fa-times"
                  } secondary-black`}
                />
              </button>

              <d className="d-flex align-items-center d-none d-sm-flex gap-2">
                <button
                  className="border-0 d-flex justify-content-center align-items-center bg-circle rounded-circle position-relative"
                  onClick={(e) => {
                    dispatch(setNotificaiton(false));
                    navigate("/notificationsList");
                  }}
                  style={{
                    width: "50px",
                    height: "50px",
                    boxShadow: "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
                  }}
                >
                  <img style={{ width: "22px", height: "22px" }} src={bell} />
                  {notificationFlag && (
                    <span className="alertBadge translate-middle p-2 bg-danger border border-light rounded-circle">
                      <span className="visually-hidden">New alerts</span>
                    </span>
                  )}
                </button>

                <Dropdown
                  isOpen={dropdownOpen[userId]}
                  toggle={() => toggleDropdown(userId)}
                  direction="down"
                >
                  <DropdownToggle tag="button" className="btn btn-link p-0">
                    <img
                      src={
                        currentUser?.additionalInfo?.profileImage
                          ? `${process.env.REACT_APP_IMG_URL}${currentUser?.additionalInfo?.profileImage}`
                          : avatar
                      }
                      alt="Profile"
                      className="object-fit-cover rounded-circle"
                      style={{
                        width: "50px",
                        height: "50px",
                        boxShadow: "0 .125rem .25rem rgba(0, 0, 0, 0.075)",
                      }}
                    />
                  </DropdownToggle>
                  <DropdownMenu end>
                    <DropdownItem
                      className="fw-normal ff-sora secondary-black font-size-14"
                      onClick={handleSettingStaff}
                    >
                      Profile settings
                    </DropdownItem>
                    <DropdownItem
                      className="fw-normal ff-sora secondary-black font-size-14"
                      onClick={() => setModalOpen(true)}
                    >
                      Logout
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </d>
            </div>
            <Modal
              isOpen={modalOpen}
              toggle={toggleModal}
              className="modal-dialog-centered rounded-4"
            >
              <ModalHeader
                toggle={toggleModal}
                className="font-size-16 fw-medium ff-sora"
              >
                Confirm logout
              </ModalHeader>
              <ModalBody className="font-size-14 fw-normal ff-sora">
                Are you sure you want to log out?
              </ModalBody>
              <ModalFooter>
                <Button
                  type="submit"
                  className=" rounded-pill"
                  onClick={handlelogout}
                >
                  Yes
                </Button>
                <Button
                  color="white"
                  className="rounded-pill1"
                  onClick={toggleModal}
                >
                  No
                </Button>
              </ModalFooter>
            </Modal>
          </Navbar>
        </div>
        {isSidebarVisible && (
          <Sidebar type={leftSideBarType} isMobile={isMobile} />
        )}

        <div className="main-content">
          {props.children}
          <Footer />
        </div>
      </div>

      {show && (
        <SettingOffcanvas
          setShow={setShow}
          show={show}
          layoutType={layoutType}
        />
      )}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeLayoutMode: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarSize: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutModeType: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
